export default {"src":"/_next/static/media/cluster-of-events.e03c92b3.svg","height":192,"width":192};